import Vue from 'vue';
import VueI18n from "vue-i18n";
import zh_CN from "@/i18n/lang/zh_CN";
import zh_TW from "@/i18n/lang/zh_TW";
import en_US from "@/i18n/lang/en_US";
import ja_JP from "@/i18n/lang/ja_JP";
import ko_KR from "@/i18n/lang/ko_KR";

import shell from './shell';
import content from './content';
import { savedLanguage } from './languages';

Vue.use(VueI18n)
const language = savedLanguage();
export default new VueI18n({
  locale: language?.type || 'zh_TW',
  fallbackLocale: 'en_US',
  messages: {
    zh_CN: { ...zh_CN, shell: shell.zh_CN, content: content.zh_CN },
    zh_TW: { ...zh_TW, shell: shell.zh_TW, content: content.zh_TW },
    en_US: { ...en_US, shell: shell.en_US, content: content.en_US },
    ja_JP: { ...ja_JP, shell: shell.ja_JP, content: content.ja_JP },
    ko_KR: { ...ko_KR, shell: shell.ko_KR, content: content.ko_KR },
  }
})